export default __webpack_public_path__ + "img/e41cc17e873ee18df054a68246251e62.svg";